<template lang="pug">
	ul.navbar-nav.account-button(v-if="User.currentUser")
		li.nav-item.px-3
			.account
				.user-photo(:style="{ backgroundImage: 'url(' + User.getPhotoUrl(User.currentUser) + ')' }" v-pseudo-modal-show="'account-dropdown'")
				.active-publisher-contacts-count.badge.badge-danger(v-show="Publisher.getActivePublisherContactsCount() > 0") {{Publisher.getActivePublisherContactsCount()}}
		.dropdown-menu(v-pseudo-modal="'account-dropdown'" :style="{'max-height': `90vh`}" ref="dropdownMenu")
			.publishers(v-if="User.currentUser.Tags['admin'] && !Metadata.Config['feature-single-publisher']" v-on:mouseover="blockUpdate" v-on:mouseleave="unblockUpdate")
				b-dropdown-header(tag="div" class="text-center")
					strong Active publishers
				PublisherSearchBar
				b-dropdown-item(v-for="publisher in publishers" :key="publisher.server_id + '-' + publisher.id" :class="{'menu-item': true, 'in-favorites': Publisher.isInFavorites(publisher), selected: Publisher.isSelectedPublisher(publisher)}" v-on:click="choosePublisher(publisher)")
					.menu-item-content
						.menu-item-title(:class="{online: isOnlineUsersExist(publisher.id) && Layout.isFeatureEnabled('online-users', 'online-users-publisher-color'), hidden: publisher.active === 0}") {{ publisher.title }}
						// Нода кластера, на которой заведён издатель: по ней понятно, куда уходят его запросы
						.menu-item-server(:class="{offline: !Cluster.isNodeConnected(publisher.server_id)}" v-if="Metadata.Servers[publisher.server_id]") {{ Metadata.Servers[publisher.server_id].title }}
						.menu-item-online(v-if="Layout.isFeatureEnabled('online-users', 'online-users-publisher-list')")
							OnlineUsersLocal(:filter="getFilterForOnlineUsers(publisher.id)" max-count="5")
						.menu-item-favorites(:class="{'in-favorites': Publisher.isInFavorites(publisher)}" v-on:click.stop="toggleFavoritePublisher(publisher, $event)")
							.fa(:class="{'fa-heart-o': !Publisher.isInFavorites(publisher), 'fa-heart': Publisher.isInFavorites(publisher)}")
			.administration(v-if="User.currentUser.Tags['admin']")
				b-dropdown-header(tag="div" class="text-center")
					strong Administration
				b-dropdown-item(v-if="!Metadata.Config['feature-single-publisher']" @click="showPublishers()")
					span Publisher list
				b-dropdown-item(v-if="Metadata.Config['feature-customer-contacts'] && Access.check('customer-contacts')" @click="showPublisherContacts()")
					span Customer contacts
					.active-publisher-contacts-count-button.badge.badge-danger(v-show="Publisher.getActivePublisherContactsCount() > 0") {{Publisher.getActivePublisherContactsCount()}}
				b-dropdown-item(v-if="Metadata.Config['feature-portfolio'] && Access.check('portfolio-access')" @click="showPortfolio()")
					span Portfolio
				b-dropdown-item(v-if="Access.check('users-list-access')" @click="showUsers()")
					span User list
				b-dropdown-item(v-if="Access.check('users-list-access')" @click="updateUsersCache()")
					span Update users cache
				b-dropdown-item(@click="updateMetadataCache()")
					span Update metadata cache
				b-dropdown-item(v-if="canSeeFiles" @click="openFiles()")
					span Files
				b-dropdown-item(v-if="User.currentUser.Tags['super-admin']" @click="openDocuments()")
					span Documents
				b-dropdown-item(v-if="User.currentUser.Tags['super-admin']" @click="openClusterNodes()")
					span Cluster nodes
				b-dropdown-item(@click="showMonitoringPage('monitoring-ai-budget')")
					span AI budget log
				b-dropdown-item(@click="showMonitoringPage('monitoring-errors-server')")
					span Server errors log
				b-dropdown-item(@click="showMonitoringPage('monitoring-errors-sql')")
					span SQL errors log
			.publisher(v-if="User.currentUser && (User.currentUser.Tags['publisher-admin'] || User.currentUser.Tags['admin']) && Publisher.SelectedPublisher")
				b-dropdown-header(tag="div" class="text-center")
					strong {{Publisher.SelectedPublisher.title}}
				b-dropdown-item(class="company-settings" @click="openPublisherSettings()")
					span Company settings
				b-dropdown-item(v-if="User.currentUser.Tags['super-admin'] || Publisher.isPublisherAdmin(Publisher.SelectedPublisher.id)" class="company-ai" @click="openPublisherAISettings()")
					span Company ai
				b-dropdown-item(v-if="Access.check('users-list-access') || User.currentUser?.['publisher_id'] === Publisher.SelectedPublisher.id" class="company-users" @click="openPublisherUsers()")
					span Users
			.account
				b-dropdown-header(tag="div" class="text-center")
					strong Account
				b-dropdown-item(v-if="canSeeFiles && !User.currentUser.Tags['admin']" @click="openFiles()")
					span Files
				b-dropdown-item(v-if="User.currentUser && User.currentUser['publisher_id'] !== 9" @click="openUserProfile()")
					span User profile
				b-dropdown-item(v-if="User.currentUser" @click="openUserAISettings()")
					span User ai
				b-dropdown-item(@click="User.logout()")
					span Logout
</template>

<script>

	import Screen 				from "./../../mixins/screen";

	import { Layout } 			from "./../../services/Layout";
	import { User } 			from "./../../services/User";
	import { Publisher } 		from "./../../services/Publisher";
	import { Creative } 			from "./../../services/Creative";
	import { Asset } 			from "./../../services/Asset";

	import OnlineUsersLocal		from "./../../components/Header/OnlineUsersLocal";
	import PublisherSearchBar 	from "./../../components/Publisher/PublisherSearchBar";

	export default {
		name: "AccountButton",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Publishers Changed",
				"Selected Publisher Changed",
				"Current User Changed",
				//"Current User Changed: [options.access]",
				"Users Online Status Changed",
				"User Online Status Changed",
				"User Online Status Added",
				"User Online Status Removed",
				"Metadata Loaded",
				"Publishers Exists Changed",
				"Customer Contacts Changed"
			],
			events: {
				"Pseudo Modal Showed account-dropdown": function() {

					if (this.$refs.dropdownMenu) {

						this.$refs.dropdownMenu.removeEventListener("scroll", this.dispatchScrollEvent);
						this.$refs.dropdownMenu.addEventListener("scroll", this.dispatchScrollEvent);

					}

				},
				"Publishers Filter Changed": function(reason) {

					if (reason === "by-user") {

						this.collectData();
						this.$forceUpdate();

					}

				}
			}
		},
		components: {
			OnlineUsersLocal,
			PublisherSearchBar
		},
		data() {

			this.User = User;
			this.Publisher = Publisher;
			this.Creative = Creative;

			this.publishers = [];

			return {
				showed: true,
				compressionCacheSize: null,
				updateBlocked: false
			}

		},
		methods: {
			collectData() {

				this.publishers = Publisher.getOrderedPublishersList(Layout.publishersFilter);
				this.compressionCacheSize = Asset.CompressionCacheSize || 0;

			},
			// блокирование обновления нужно, чтобы список паблишеров не перестраивался сразу как нажмешь на иконку добавления в избранное.
			blockUpdate() {

				this.updateBlocked = true;

			},
			unblockUpdate() {

				this.updateBlocked = false;
				this.update();

			},
			// Раздел Files доступен для своего паблишера, а к чужим - только супер-админам.
			// Пункт меню можно скрыть настройкой паблишера (как раньше для главного меню)
			canSeeFiles() {

				if (!Publisher.SelectedPublisher || !User.currentUser) return false;
				if (_.get(Publisher, 'SelectedPublisher.options.mainMenu.files') === false) return false;
				if (User.currentUser.Tags['super-admin']) return true;

				return Publisher.SelectedPublisher.id === User.currentUser['publisher_id'];

			},
			isOnlineUsersExist(publisherId) {

				return _.find(User.usersOnlineStatus.Users, userData => userData.publisherId === publisherId);

			},
			getFilterForOnlineUsers(publisherId) {

				return userData => userData.publisherId === publisherId;

			},
			choosePublisher(publisher) {

				//Смена ноды кластера: активные карты сервисов подменяются картами этой ноды,
				//данные прежней ноды остаются в её картах (Client/App/services/Publisher.js, selectPublisher)
				Publisher.switchPublisher(publisher);

				if (!['playables', 'banners', 'end-cards', 'storyboards', 'editable-playables', 'marker'].includes(Layout.page)) Layout.setPage("playables");

				Broadcast.call("Pseudo Modal Hide", ["account-dropdown"]);

			},
			toggleFavoritePublisher(publisher) {

				if (!User.currentUser.options.favoritePublishers) User.currentUser.options.favoritePublishers = [];

				if (User.currentUser.options.favoritePublishers.includes(publisher.id)) User.currentUser.options.favoritePublishers = _.without(User.currentUser.options.favoritePublishers, publisher.id);
				else User.currentUser.options.favoritePublishers.push(publisher.id);

				Server.sendWithTimeout({
					UpdateUserOption: {
						optionName: 'favoritePublishers',
						optionValue: User.currentUser.options.favoritePublishers
					}
				}, null, 1000);

				this.$forceUpdate();

			},
			updateUsersCache() {

				Server.sendToSocket({
					UpdateUsersCache: true
				});

				Broadcast.call("Pseudo Modal Hide", ["account-dropdown"]);

			},
			updateMetadataCache() {

				Server.sendToSocket({
					UpdateMetadataCache: true
				});

				Broadcast.call("Pseudo Modal Hide", ["account-dropdown"]);

			},
			// Открываем файловый менеджер отдельным окном
			openFiles() {

				Broadcast.call("Show File");

				Broadcast.call("Pseudo Modal Hide", ["account-dropdown"]);

			},
			// Открываем защищённый раздел Documents отдельным окном (только для супер-админов)
			openDocuments() {

				Broadcast.call("Show Documents");

				Broadcast.call("Pseudo Modal Hide", ["account-dropdown"]);

			},
			// Открываем мониторинг нод кластера отдельным окном (только для супер-админов)
			openClusterNodes() {

				Broadcast.call("Show ClusterNodes");

				Broadcast.call("Pseudo Modal Hide", ["account-dropdown"]);

			},
			showMonitoringPage(page) {

				Layout.setPage(page, {});

				Broadcast.call("Pseudo Modal Hide", ["account-dropdown"]);

			},
			showPublishers() {

				Layout.setPage("publisher-list");

				Broadcast.call("Pseudo Modal Hide", ["account-dropdown"]);

			},
			showPublisherContacts() {

				Layout.setPage("publisher-contacts");

				Broadcast.call("Pseudo Modal Hide", ["account-dropdown"]);

			},
			showPortfolio() {

				Broadcast.call("Show Portfolio");

				Broadcast.call("Pseudo Modal Hide", ["account-dropdown"]);

			},
			showUsers() {

				Layout.setPage("user-list");

				Broadcast.call("Pseudo Modal Hide", ["account-dropdown"]);

			},
			openPublisherSettings() {

				Layout.setPage("publisher-settings");

				Broadcast.call("Pseudo Modal Hide", ["account-dropdown"]);

			},
			openPublisherAISettings() {

				Broadcast.call("Show PublisherSettingsAI");

				Broadcast.call("Pseudo Modal Hide", ["account-dropdown"]);

			},
			openPublisherUsers() {

				Layout.setPage("publisher-users");

				Broadcast.call("Pseudo Modal Hide", ["account-dropdown"]);

			},
			openUserProfile() {

				Layout.setPage("user-profile", {userId: User.currentUser.id});

				Broadcast.call("Pseudo Modal Hide", ["account-dropdown"]);

			},
			openUserAISettings() {

				Broadcast.call("Show UserSettingsAI", [User.currentUser.id]);

				Broadcast.call("Pseudo Modal Hide", ["account-dropdown"]);

			},
			dispatchScrollEvent() {

				Broadcast.call("Account Settings Dropdown Scroll");

			}
		}
	}
</script>

<style lang="sass">

	ul.account-button
		list-style: none
		position: relative

		a.nav-link.download
			font-size: 25px
			line-height: 23px

		.dropdown-header
			cursor: default

		.dropdown-menu
			position: absolute
			left: -197px
			top: 43px
			width: 250px
			display: block
			z-index: 10000
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)
			line-height: 1

			.icon
				margin-left: 6px

			.menu-item-content
				display: flex
				flex-direction: row
				justify-content: stretch
				position: relative

				.menu-item-title
					display: flex

					&.hidden
						color: var(--gray)

					&.online
						color: #4dbd74

				.menu-item-server
					margin-left: 6px
					font-size: 0.8rem
					white-space: nowrap
					color: #9da5b1

					&.offline
						color: #f86c6b

				.menu-item-online
					display: flex
					width: 100%
					margin-left: 10px

					.c-avatar-status
						display: none

				.menu-item-favorites
					position: absolute
					width: 20px
					height: 20px
					right: -10px
					top: -5px
					padding: 5px
					color: #515b65
					visibility: hidden

					&.in-favorites
						color: var(--orange)

			li:not(:first-child)
				.dropdown-item
					border-top: 1px solid rgba(0, 0, 0, 0.2)

			li:nth-child(2)
				.dropdown-item
					border-top: none

			li.selected

				.dropdown-item
					background-color: #20a8d8

					.menu-item-title.online
						color: #ffffff

			li.menu-item.in-favorites
				border-left: 1px solid var(--orange)

			li.menu-item:hover

				.menu-item-content

					.menu-item-favorites
						visibility: visible

					.menu-item-favorites:hover
						color: var(--orange)

		.publishers, .administration, .publisher
			border-bottom: 1px solid #23282c

		.dropdown-menu
			overflow-x: hidden
			overflow-y: auto

			&::-webkit-scrollbar
				position: fixed
				width: 8px
				margin-left: -8px
				-webkit-appearance: none
				appearance: none

			&::-webkit-scrollbar-track
				background-color: rgba(0, 0, 0, 0.08)

			&::-webkit-scrollbar-thumb
				background-color: rgba(0, 0, 0, 0.36)
				background-clip: content-box
				border-color: transparent
				border-radius: 5px

		.nav-link,
		.nav-link:focus
			color: #c8ced3

		.nav-link:hover
			color: #fff

		.user-photo
			background: center / auto 100% no-repeat
			width: 35px
			height: 35px
			border-radius: 35px
			cursor: pointer
			image-rendering: -webkit-optimize-contrast

		.active-publisher-contacts-count
			position: absolute
			right: 5px
			top: -5px

		.active-publisher-contacts-count-button
			position: absolute
			right: 10px
			top: 7px

</style>

